/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReadyInputs */

const en_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I’m Ready`)
};

const ar_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنا مستعد`)
};

const de_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich bin bereit`)
};

const es_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estoy preparado`)
};

const fr_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je suis prêt`)
};

const it_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono pronto`)
};

const ja_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備OK`)
};

const ko_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`준비됐어요`)
};

const pt_br_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estou pronto`)
};

const ru_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я готов(а)`)
};

const th_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฉันพร้อมแล้ว`)
};

const tr_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazırım`)
};

const zh_cn_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备好了`)
};

const zh_tw_ready = /** @type {(inputs: ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備好了`)
};

/**
* | output |
* | --- |
* | "I’m Ready" |
*
* @param {ReadyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const ready = /** @type {((inputs?: ReadyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReadyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ready(inputs)
	if (locale === "ar") return ar_ready(inputs)
	if (locale === "de") return de_ready(inputs)
	if (locale === "es") return es_ready(inputs)
	if (locale === "fr") return fr_ready(inputs)
	if (locale === "it") return it_ready(inputs)
	if (locale === "ja") return ja_ready(inputs)
	if (locale === "ko") return ko_ready(inputs)
	if (locale === "pt_br") return pt_br_ready(inputs)
	if (locale === "ru") return ru_ready(inputs)
	if (locale === "th") return th_ready(inputs)
	if (locale === "tr") return tr_ready(inputs)
	if (locale === "zh_cn") return zh_cn_ready(inputs)
	return zh_tw_ready(inputs)
});